module.exports = __webpack_public_path__ + "img/logo-shadow.7a3f0c92.png";